import { Button, ConfigProvider, Layout, Space, Typography, theme as antdTheme } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useTernaryDarkMode } from 'usehooks-ts';
import AsideMenu from '@/components/aside-menu';
import { getStaffToken, getStaffUser, setStaffToken } from '@/adminHost';
import '@/components/layout/DashboardLayout.less';

const { Text } = Typography;

const AdminShellLayout: FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTernaryDarkMode({ localStorageKey: 'theme' });
  const [collapsed, setCollapsed] = useState(false);
  const staff = getStaffUser();

  useEffect(() => {
    if (!getStaffToken()) {
      navigate('/admin/sign-in', { replace: true });
    }
  }, [navigate]);

  const onSignOut = useCallback(() => {
    setStaffToken(null);
    navigate('/admin/sign-in', { replace: true });
  }, [navigate]);

  if (!getStaffToken()) {
    return null;
  }

  return (
    <ConfigProvider theme={{ algorithm: isDarkMode ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm }}>
      <Layout className={`${isDarkMode ? 'dark' : 'light'} main-app-layout`}>
        <Layout.Sider
          width={250}
          className="main-sidebar"
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          breakpoint="lg"
          collapsedWidth={60}
          trigger={null}
        >
          <AsideMenu collapsed={collapsed} onToggleCollapse={() => setCollapsed((value) => !value)} />
        </Layout.Sider>
        <Layout.Content className="default-layout-content">
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 24px 0' }}>
            <Space>
              <Text type="secondary">{staff?.email || 'Staff'}</Text>
              <Button size="small" onClick={onSignOut}>Sign out</Button>
            </Space>
          </div>
          <Outlet />
        </Layout.Content>
      </Layout>
    </ConfigProvider>
  );
};

export default AdminShellLayout;
